import script from "./AcceptInvite.vue?vue&type=script&setup=true&lang=js"
export * from "./AcceptInvite.vue?vue&type=script&setup=true&lang=js"

import "./AcceptInvite.vue?vue&type=style&index=0&id=426c6f38&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-426c6f38"]])

export default __exports__